<template> 
       <!-- web vendor menu -->
       <div class="dropdown-menu vendor-menu" aria-labelledby="vendor-menu-btn">
            <a class="dropdown-item" :href="'/salon/'+user.salon.name"><span class="fas fa-home fa-fw"></span>Početna</a>
            <!--
            <a @click="openPage('nadzorna')" class="dropdown-item" href="/vendor#nadzorna"><span class="fas fa-tachometer-alt fa-fw"></span>Nadzorna ploča</a>
            -->
            <!--
            <a @click="openPage('terminiNav')" class="dropdown-item" href="/vendor#terminiNav"><span class="far fa-calendar-check fa-fw"></span>Rezervacije</a>
            -->
            <a @click="openPage('raspored')" class="dropdown-item" href="/vendor#raspored"><span class="far fa-calendar-alt fa-fw"></span>Raspored</a>
            <a @click="openPage('komentari')" class="dropdown-item" href="/vendor#komentari"><span class="far fa-comments fa-fw"></span>Komentari</a>
            <a @click="openPage('usluge')" class="dropdown-item" href="/vendor#usluge"><span class="fas fa-hand-holding-usd fa-fw"></span>Usluge</a>
            <a @click="openPage('galerija')" class="dropdown-item" href="/vendor#galerija"><span class="far fa-images fa-fw"></span>Galerija</a>
            <a @click="openPage('salon')" class="dropdown-item" href="/vendor#salon"><span class="fas fa-store fa-fw"></span>Salon</a>
            <a @click="openPage('zaposlenici')" class="dropdown-item" href="/vendor#zaposlenici"><span class="fas fa-user-friends fa-fw"></span>Djelatnici</a>
            <a @click="openPage('postavke')" class="dropdown-item" href="/vendor#postavke" ><span class="fas fa-cog fa-fw"></span>Postavke profila</a>
            <div class="dropdown-divider"></div>
            <a @click="logoutNow($event)" class="dropdown-item" href="/vendor#"><span class="fas fa-sign-out-alt fa-fw"></span>Odjavi se</a>
        </div>   
</template>

<script>
import { mapState } from 'vuex'
export default {
    name:'authDropDown',
    computed:{
        ...mapState({
            user:(state)=>state.user
        })
    },
    methods:{
        logoutNow(e){
            e.preventDefault(); 
            this.$store.commit('logout');
            window.location.href='/';
        },
        openPage(page){
            setTimeout(()=>{
                document.getElementById(page).click();
            },500);
        }
    },
    mounted(){ 
    }
}
</script>